import { Component, ChangeDetectionStrategy } from '@angular/core';

import { DarkModeService } from '../../../../core/services/dark-mode.service';

@Component({
  selector: 'ngx-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SidebarComponent {
  constructor(public darkModeService: DarkModeService) {}
}
